import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import ContentLos from "../../../components/ContentLos/Content/ContentLos";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";

class PendingLOs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      type: 1,
      typeName: "Todos",
      typeIcon: "",
      typeColor: "",
      types: []
    };
  }

  componentDidMount() {
    this.initContent();
  }

  initContent() {
    this.setState({ loading: true });
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    axios
      .get(`${URL.api}content/type/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ types: resp.data.data, loading: false });
      });
  }

  render() {
    const query = new URLSearchParams(this.props.location.search);
    const serie = query.get("serie") || null;
    const discipline = query.get("discipline") || null;

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <div className="p-4">
            <Loading />
          </div>
        ) : (
          <ContentLos
            type={this.state.type}
            typeName={this.state.typeName}
            typeIcon={this.state.typeIcon}
            typeColor={this.state.typeColor}
            types={this.state.types}
            currentRoute={this.props.currentRoute}
            serie={serie}
            discipline={discipline}
            peddingClasses
          />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PendingLOs);
